var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import UserRole from 'shared-assets/lib/sdk/kUserRoles';
import { getCompanyTypeName } from 'shared-assets/lib/sdk/practiceProperties';
function hasRoleId(roles, roleId) {
    if (!!roles && Array.isArray(roles)) {
        return roles.some(function (role) { return role.id === roleId; });
    }
    return false;
}
/**
 * Get an object with flags for the roles use for segmentation
 * @param {Array} K_ROLES - Receives the Kareo Roles constant
 * @param {Array} userRoles - List of user roles
 * @return {Object} - Object with flags for the roles
 */
export function getUserRoleFlagsObject(K_ROLES, userRoles) {
    if (K_ROLES === void 0) { K_ROLES = UserRole; }
    if (userRoles === void 0) { userRoles = []; }
    return {
        isSystemAdministrator: hasRoleId(userRoles, K_ROLES.ADMIN),
        isProvider: hasRoleId(userRoles, K_ROLES.PROVIDER),
        isClinicalAssistant: hasRoleId(userRoles, K_ROLES.CLINICAL_ASSISTANT),
        isOfficeStaff: hasRoleId(userRoles, K_ROLES.OFFICE_STAFF),
        isBiller: hasRoleId(userRoles, K_ROLES.BILLER),
        isBusinessManager: hasRoleId(userRoles, K_ROLES.BUSINESS_MANAGER),
    };
}
export function getUserInfoQueryParams(segmentationInfo) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var searchParams = new URLSearchParams();
    if (!!(segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.user)) {
        if (!!((_a = segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.user) === null || _a === void 0 ? void 0 : _a.userName)) {
            searchParams.append('email', segmentationInfo.user.userName);
        }
        if (!!((_b = segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.user) === null || _b === void 0 ? void 0 : _b.firstName)) {
            searchParams.append('first_name', segmentationInfo.user.firstName);
        }
        if (!!((_c = segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.user) === null || _c === void 0 ? void 0 : _c.lastName)) {
            searchParams.append('last_name', segmentationInfo.user.lastName);
        }
    }
    if (!!((_d = segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.user) === null || _d === void 0 ? void 0 : _d.roles) &&
        ((_e = segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.user) === null || _e === void 0 ? void 0 : _e.roles.length) > 0) {
        var rolesString = (_f = segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.user) === null || _f === void 0 ? void 0 : _f.roles.map(function (role) { return role.name; }).join('|');
        searchParams.append('user_roles', rolesString);
    }
    if (!!(segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practice)) {
        if (!!((_g = segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practice) === null || _g === void 0 ? void 0 : _g.name)) {
            searchParams.append('practice_name', segmentationInfo.practice.name);
        }
        if (!!((_h = segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practice) === null || _h === void 0 ? void 0 : _h.phoneNumber)) {
            searchParams.append('practice_phone', segmentationInfo.practice.phoneNumber);
        }
        if (!!((_j = segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practice) === null || _j === void 0 ? void 0 : _j.zip)) {
            searchParams.append('practice_zip', segmentationInfo.practice.zip);
        }
    }
    if (!!(segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practiceSpecialty)) {
        searchParams.append('practice_specialty', segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practiceSpecialty);
    }
    if (!!(segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.providerCount)) {
        searchParams.append('providers', segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.providerCount.toString());
    }
    if (!!(segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.userType)) {
        searchParams.append('user_type', segmentationInfo.userType);
    }
    return searchParams;
}
export function mapRequestToSegmentationInfo(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var user = _a[0], practice = _a[1], practiceProperties = _a[2], currentUser = _a[3], providers = _a[4];
    if (!user || !practice || !practiceProperties || !currentUser) {
        return null;
    }
    var userRoleFlags = getUserRoleFlagsObject(UserRole, currentUser === null || currentUser === void 0 ? void 0 : currentUser.roles);
    var segmentation = __assign(__assign({ email: user === null || user === void 0 ? void 0 : user.email, userId: user === null || user === void 0 ? void 0 : user.pmUserId, pmEnabled: practice === null || practice === void 0 ? void 0 : practice.pmenabled, isJointCustomer: practiceProperties === null || practiceProperties === void 0 ? void 0 : practiceProperties.isPatientPopPartnerActive, companyType: getCompanyTypeName(practiceProperties === null || practiceProperties === void 0 ? void 0 : practiceProperties.companyType), practiceSpecialty: practiceProperties === null || practiceProperties === void 0 ? void 0 : practiceProperties.practiceSpecialty, pricingFamily: (_b = practiceProperties === null || practiceProperties === void 0 ? void 0 : practiceProperties.editionType) === null || _b === void 0 ? void 0 : _b.caption, hasBillingProduct: !!((_d = (_c = currentUser === null || currentUser === void 0 ? void 0 : currentUser.providerInfo) === null || _c === void 0 ? void 0 : _c.products) === null || _d === void 0 ? void 0 : _d.PM), hasClinicalProduct: !!((_f = (_e = currentUser === null || currentUser === void 0 ? void 0 : currentUser.providerInfo) === null || _e === void 0 ? void 0 : _e.products) === null || _f === void 0 ? void 0 : _f.KAREO_EHR), hasEngageProduct: !!((_h = (_g = currentUser === null || currentUser === void 0 ? void 0 : currentUser.providerInfo) === null || _g === void 0 ? void 0 : _g.products) === null || _h === void 0 ? void 0 : _h.KAREO_OFFICE), hasTelehealthProduct: !!((_k = (_j = currentUser === null || currentUser === void 0 ? void 0 : currentUser.providerInfo) === null || _j === void 0 ? void 0 : _j.products) === null || _k === void 0 ? void 0 : _k.KAREO_TELEHEALTH) }, userRoleFlags), { userType: !!(userRoleFlags === null || userRoleFlags === void 0 ? void 0 : userRoleFlags.isProvider) ? 'Provider' : 'Non-Provider', user: user,
        practice: practice, providerCount: (!!providers && Array.isArray(providers) && providers.length) || 0 });
    return segmentation;
}
